import { ref } from 'vue';
import { pendingTransactionUpdateId } from '@/components/elements/transactionUpdateState';
// Per-page hook for the post-category-change spinner handoff.
//
// On mount, the landing page (AccountPage / MoneyPage / SpendingAnalysisPage)
// calls takePending() to adopt the global pendingTransactionUpdateId. That
// shows the row spinner immediately while the page's own SWR+poll fetch waits
// for the server payload to reflect the change; when fresh data lands the page
// clears updatingTransactionId via the !isStale callback.
export function useTransactionUpdateHandoff() {
    const updatingTransactionId = ref(null);
    function takePending() {
        const id = pendingTransactionUpdateId.value;
        if (id)
            updatingTransactionId.value = id;
        pendingTransactionUpdateId.value = null;
        return { id };
    }
    return { updatingTransactionId, takePending };
}
